// extracted by mini-css-extract-plugin
export default {"signupHeader":"signupHeader-1gGGt","signupHeaderTitle":"signupHeaderTitle-kVKIu","firstTextLine":"firstTextLine-eoWTK","secondTextLine":"secondTextLine-3ANx7"};